export interface Manga {
  id: string;
  slug: string;
  title: string;
  subtitle: string;
  synopsis: string;
  cover: string;
  category: string;
  categoryName: string;
  chapters: number;
  rating: number;
  author: string;
  status: string;
  heat: number;
  latestChapter: string;
  tags: string[];
  year: number;
  isHot?: boolean;
  isNew?: boolean;
  isFeatured?: boolean;
  views: string;
}

export const categories = [
  { slug: "love", name: "恋爱" },
  { slug: "campus", name: "校园" },
  { slug: "daily", name: "日常" },
  { slug: "healing", name: "治愈" },
  { slug: "comedy", name: "搞笑" },
  { slug: "sports", name: "运动" },
];

export const mangaList: Manga[] = [
  {
    id: "overflow-pool",
    slug: "man-yi-you-yong-chi",
    title: "满溢游泳池",
    subtitle: "喜欢同班同学，从游泳馆开始",
    synopsis: "夏日到来，游泳馆重新开放。内向的转学生小满在泳池边遇到了温柔而耀眼的游泳部部长林澈。每一次训练、每一次并肩划水，藏在心口的心意都像泳池里的水一样，一点一点漫过边缘。青春、汗水与青涩的喜欢，在这个夏天悄然满溢。",
    cover: "https://readdy.ai/api/search-image?query=romantic%20anime%20style%20manga%20cover%20illustration%20of%20a%20young%20girl%20wearing%20a%20swimming%20cap%20at%20a%20bright%20summer%20outdoor%20pool%2C%20soft%20coral%20and%20teal%20color%20palette%2C%20clean%20minimal%20composition%2C%20water%20reflections%20and%20floating%20light%20bokeh%2C%20cheerful%20youthful%20atmosphere%2C%20high%20detail%20illustration%2C%20smooth%20rendering&width=600&height=800&seq=cover-overflow-01&orientation=portrait",
    category: "love",
    categoryName: "恋爱",
    chapters: 42,
    rating: 9.2,
    author: "青山空",
    status: "连载中",
    heat: 128000,
    latestChapter: "第42话 夏日终曲",
    tags: ["恋爱", "校园", "运动"],
    year: 2024,
    isHot: true,
    isNew: true,
    isFeatured: true,
    views: "128.6万",
  },
  {
    id: "moonlight-cafeteria",
    slug: "yue-guang-shi-tang",
    title: "月光食堂",
    subtitle: "深夜食堂里，藏着两个人的秘密",
    synopsis: "每到深夜，学校后巷的月光食堂就会亮起暖黄的灯。两位常客在这里交换心事，也在不知不觉中交换了喜欢。一碗热汤面，两杯柠檬水，藏着说不出口的心意。",
    cover: "https://readdy.ai/api/search-image?query=cozy%20warm%20anime%20style%20manga%20cover%20of%20a%20cozy%20night%20canteen%20with%20two%20teenagers%20sitting%20across%20a%20small%20table%20with%20hot%20noodles%2C%20warm%20amber%20lamp%20light%2C%20romantic%20atmosphere%2C%20soft%20teal%20and%20coral%20accent%20tones%2C%20clean%20minimal%20composition%2C%20high%20detail%20illustration&width=600&height=800&seq=cover-moonlight-02&orientation=portrait",
    category: "healing",
    categoryName: "治愈",
    chapters: 36,
    rating: 9.0,
    author: "半糖不加冰",
    status: "连载中",
    heat: 96000,
    latestChapter: "第36话 星夜面汤",
    tags: ["治愈", "日常", "恋爱"],
    year: 2024,
    isHot: true,
    views: "96.2万",
  },
  {
    id: "sprint-studio",
    slug: "feng-su-hua-shi",
    title: "风速画室",
    subtitle: "画笔与心跳，同频共振",
    synopsis: "画室里总有人安静地画到很晚。新来的美术生阿速与高冷的学姐在一次次速写中靠近，色彩与心跳渐渐同频。当画笔落下，喜欢也悄悄被画进了画面里。",
    cover: "https://readdy.ai/api/search-image?query=sweet%20anime%20style%20manga%20cover%20of%20an%20art%20studio%20with%20easels%20and%20colorful%20paintings%2C%20a%20boy%20and%20girl%20painting%20together%2C%20soft%20natural%20window%20light%2C%20coral%20and%20mint%20accent%20palette%2C%20clean%20minimal%20layout%2C%20high%20detail%20illustration&width=600&height=800&seq=cover-sprint-03&orientation=portrait",
    category: "campus",
    categoryName: "校园",
    chapters: 29,
    rating: 8.8,
    author: "纸飞机",
    status: "连载中",
    heat: 71000,
    latestChapter: "第29话 调色",
    tags: ["校园", "恋爱"],
    year: 2025,
    isNew: true,
    views: "71.4万",
  },
  {
    id: "bubble-tea-love",
    slug: "nai-cha-yuan-liao",
    title: "奶茶圆了",
    subtitle: "甜度刚刚好的喜欢",
    synopsis: "校园门口的奶茶店，是放学后的聚集地。店长的笨拙学徒与点单时总爱加料的学长，因为一杯珍珠奶茶，开启了一段甜度刚刚好的故事。",
    cover: "https://readdy.ai/api/search-image?query=playful%20anime%20style%20manga%20cover%20of%20a%20milk%20tea%20shop%20with%20cute%20characters%20holding%20cups%20with%20bubble%20pearls%2C%20bright%20coral%20and%20cream%20tones%2C%20cheerful%20and%20sweet%20mood%2C%20clean%20minimal%20composition%2C%20high%20detail%20illustration&width=600&height=800&seq=cover-bubble-04&orientation=portrait",
    category: "daily",
    categoryName: "日常",
    chapters: 52,
    rating: 8.6,
    author: "三分甜",
    status: "已完结",
    heat: 85000,
    latestChapter: "第52话 完结篇",
    tags: ["日常", "恋爱", "搞笑"],
    year: 2023,
    views: "85.9万",
  },
  {
    id: "summer-echo",
    slug: "xia-tian-hui-sheng",
    title: "夏天回声",
    subtitle: "那个夏天，我们都会记得",
    synopsis: "毕业前的最后一个夏天，少年们在海边小镇参加了一次难忘的夏令营。篝火、烟花、未说出口的告白，以及被海风带走的遗憾与心动，都在这个夏天留下回声。",
    cover: "https://readdy.ai/api/search-image?query=nostalgic%20anime%20style%20manga%20cover%20of%20summer%20camp%20by%20the%20seaside%20with%20fireworks%20and%20campfire%2C%20warm%20sunset%20coral%20tones%20with%20teal%20night%20sky%2C%20dreamy%20and%20sentimental%20mood%2C%20clean%20minimal%20composition%2C%20high%20detail%20illustration&width=600&height=800&seq=cover-summer-05&orientation=portrait",
    category: "campus",
    categoryName: "校园",
    chapters: 48,
    rating: 9.1,
    author: "晚风电台",
    status: "连载中",
    heat: 112000,
    latestChapter: "第48话 篝火晚会",
    tags: ["校园", "恋爱", "治愈"],
    year: 2024,
    isHot: true,
    views: "112.3万",
  },
  {
    id: "relay-race",
    slug: "jiao-li-deng-pao",
    title: "接力灯跑",
    subtitle: "最后一棒，交给你了",
    synopsis: "田径队里沉默寡言的短跑新星，与一直照顾他的队长，在一次次接力与训练中建立了羁绊。汗水与呐喊里，藏着并肩作战的默契与心意。",
    cover: "https://readdy.ai/api/search-image?query=dynamic%20anime%20style%20manga%20cover%20of%20two%20teenage%20runners%20on%20an%20outdoor%20track%20handing%20a%20relay%20baton%2C%20coral%20track%20and%20teal%20sky%2C%20energetic%20sports%20mood%2C%20clean%20minimal%20composition%2C%20high%20detail%20illustration&width=600&height=800&seq=cover-relay-06&orientation=portrait",
    category: "sports",
    categoryName: "运动",
    chapters: 33,
    rating: 8.9,
    author: "阿满",
    status: "连载中",
    heat: 67000,
    latestChapter: "第33话 冲刺",
    tags: ["运动", "校园"],
    year: 2025,
    isNew: true,
    views: "67.8万",
  },
  {
    id: "cat-diary",
    slug: "mao-mi-note",
    title: "猫咪日记",
    subtitle: "今天也要被毛茸茸治愈",
    synopsis: "一条关于流浪猫与咖啡店老板娘的日常漫画。每天都有新的猫咪光顾，也每天都有新的温暖发生。看着这些毛茸茸的小家伙，整个人的心情都变好了。",
    cover: "https://readdy.ai/api/search-image?query=adorable%20anime%20style%20manga%20cover%20of%20cute%20cats%20in%20a%20cozy%20coffee%20shop%20with%20a%20barista%2C%20soft%20cream%20and%20coral%20tones%2C%20warm%20and%20healing%20mood%2C%20clean%20minimal%20composition%2C%20high%20detail%20illustration&width=600&height=800&seq=cover-cat-07&orientation=portrait",
    category: "healing",
    categoryName: "治愈",
    chapters: 60,
    rating: 9.4,
    author: "奶盖",
    status: "连载中",
    heat: 134000,
    latestChapter: "第60话 午后阳光",
    tags: ["治愈", "日常", "搞笑"],
    year: 2024,
    isHot: true,
    views: "134.8万",
  },
  {
    id: "desk-neighbor",
    slug: "tong-zhuo-de-mi-mi",
    title: "同桌的秘密",
    subtitle: "纸条背后的心事",
    synopsis: "每天传纸条的同桌，突然有一天不再回应。原来每一次递来的橡皮、每一个小小的玩笑，都藏着没有说出口的喜欢。班级日常里，恋爱悄悄发芽。",
    cover: "https://readdy.ai/api/search-image?query=cute%20anime%20style%20manga%20cover%20of%20two%20deskmates%20sharing%20a%20classroom%20desk%20passing%20a%20small%20paper%20note%2C%20soft%20coral%20and%20mint%20tones%2C%20innocent%20and%20sweet%20mood%2C%20clean%20minimal%20composition%2C%20high%20detail%20illustration&width=600&height=800&seq=cover-desk-08&orientation=portrait",
    category: "campus",
    categoryName: "校园",
    chapters: 40,
    rating: 8.7,
    author: "透明胶带",
    status: "连载中",
    heat: 59000,
    latestChapter: "第40话 传纸条",
    tags: ["校园", "恋爱", "日常"],
    year: 2025,
    isNew: true,
    views: "59.3万",
  },
  {
    id: "rainy-umbrella",
    slug: "yu-zhong-de-yu",
    title: "雨中的伞",
    subtitle: "那把伞，撑起两个人的晴天",
    synopsis: "每年梅雨季都会下雨，而总有一把伞会在图书馆门口等她。从陌生人到熟悉，从伞下的沉默到伞下的约定，一段在雨天里慢慢升温的恋爱。",
    cover: "https://readdy.ai/api/search-image?query=romantic%20anime%20style%20manga%20cover%20of%20two%20people%20sharing%20an%20umbrella%20under%20soft%20rain%20by%20a%20library%2C%20moody%20teal%20and%20coral%20tones%2C%20gentle%20and%20tender%20mood%2C%20clean%20minimal%20composition%2C%20high%20detail%20illustration&width=600&height=800&seq=cover-rain-09&orientation=portrait",
    category: "love",
    categoryName: "恋爱",
    chapters: 27,
    rating: 8.9,
    author: "小雨点",
    status: "连载中",
    heat: 88000,
    latestChapter: "第27话 屋檐下",
    tags: ["恋爱", "校园"],
    year: 2025,
    isNew: true,
    views: "88.6万",
  },
  {
    id: "mystery-cafe",
    slug: "shen-mi-ka-fei",
    title: "神秘咖啡馆",
    subtitle: "每一杯咖啡都有一段故事",
    synopsis: "小镇角落的神秘咖啡馆，只有有缘人才能找到。老板娘能读懂客人的心事，用一杯杯特调咖啡，治愈每个带着烦恼而来的人。轻松日常中带着一点点温暖与悬疑。",
    cover: "https://readdy.ai/api/search-image?query=whimsical%20anime%20style%20manga%20cover%20of%20a%20cozy%20mysterious%20coffee%20shop%20interior%20with%20steaming%20coffee%20cups%20and%20warm%20lights%2C%20teal%20and%20amber%20tones%2C%20cozy%20storybook%20mood%2C%20clean%20minimal%20composition%2C%20high%20detail%20illustration&width=600&height=800&seq=cover-cafe-10&orientation=portrait",
    category: "daily",
    categoryName: "日常",
    chapters: 44,
    rating: 8.8,
    author: "深烘焙",
    status: "已完结",
    heat: 72000,
    latestChapter: "第44话 尾韵",
    tags: ["日常", "治愈", "搞笑"],
    year: 2023,
    views: "72.7万",
  },
];